<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark bg-primary"> 
        <a href="#menu-toggle" id="menu-toggle" class="navbar-brand" v-on:click.prevent="toggle">
          <span class="navbar-toggler-icon"></span></a> 
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample02" aria-controls="navbarsExample02" aria-expanded="false" aria-label="Toggle navigation"> <span class="navbar-toggler-icon"></span> </button>
            <div class="collapse navbar-collapse" id="navbarsExample02">
                <ul class="navbar-nav mr-auto">
                    <li class="nav-item"> <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a> </li>                                    
                
                </ul>
                <form class="form-inline my-2 my-md-0"> </form>
            </div>
            <carro-mini></carro-mini> 
    </nav>
    
    <div id="wrapper" :class="toggleClass">

            <!-- Page Content -->
            <div id="page-content-wrapper">
              
                <!-- Sidebar -->
                <div id="sidebar-wrapper">
                    <ul class="sidebar-nav">
                        <li class="sidebar-brand" style="display:none"></li>
                        <li v-for="seccion in secciones" :seccion="seccion" :key="seccion.id">
                           <boton-seccion  :seccion="seccion" >
                          </boton-seccion>
                        </li>                    
                    </ul>
                </div> <!-- /#sidebar-wrapper -->
                  
                <div class="container-fluid"> 
                    <nav aria-label="breadcrumb" style="display:none;visibility:hidden">>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item" v-for="c in crumbs" :key="c" aria-current="page">{{c}}</li>
                </ol>
              </nav>
                <keep-alive>
                      <router-view></router-view>
                </keep-alive>
                <home></home>
  
                
                </div>
            </div> <!-- /#page-content-wrapper -->
      </div> <!-- /#wrapper -->



    <!-- <div class="contenedorContenido" id="app-section">
      <div class="contenedorContenidoCentralDerecho">
              
              <div class="contenedorBotonesCategorias">
                <boton-seccion v-for="seccion in secciones" :seccion="seccion" :key="seccion.id">
                </boton-seccion>
              </div>
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item" v-for="c in crumbs" :key="c" aria-current="page">{{c}}</li>
                </ol>
              </nav>
                <keep-alive>
                      <router-view></router-view>
                </keep-alive>
                <home></home>
  
                <carro-mini></carro-mini>            
      </div>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import { bus } from "./main.js";
import { i18n } from "./assets/js/i18n.js";
import Servicios from "./services.js";
import { Seccion } from "./model.js";

// Components
import BotonSeccion from "./components/BotonSeccion.vue";
import CarroMini from "./components/CarroMini.vue";

export default {
  name: "app",
  data() {
    return {
      toggleClass: '',
      secciones: [
        {
          Id: -1,
          Href: "/",
          ImgUrl: "dist/img/icon-home.png",
          Css: "botonCategorias",
          Nombre: this.$t("menu.inicio"),
        },
        {
          Id: 0,
          Href: { name: "promotions" },
          ImgUrl: "dist/img/icon-promo-pq.png",
          Css: "botonCategorias",
          Nombre: this.$t("menu.promociones"),
        },
      ],
    };
  },
  props: {
    seccion: Object,
  },
  components: {
    BotonSeccion,
    CarroMini,
  },
  methods:{
    toggle() {
      console.log("click toggle", )
      if(this.toggleClass)
        this.toggleClass = '';
        else
        this.toggleClass='toggled';
    }
  },
  computed: {
    testTotal() {
      console.log("this.$store", this.$store);
      return this.$store.getters["getTotal"];
    },
    crumbs: function() {
      let pathArray = this.$route.path.split("/");
      console.log("pathArray", pathArray);
      return pathArray;
    },
  },

  async created() {
    // Cargar secciones
    var vm = this;
    let respuesta = await Servicios.ObtenerSecciones();    
    respuesta.data.d.forEach((reg) => {
      var seccion = new Seccion();
      seccion.Id = reg.Id;
      seccion.Nombre = reg.Nombre;
      seccion.Href = { name: "section", params: { id: reg.Id } };
      seccion.ImgUrl = "#";
      seccion.Css = "botonCategorias";

      vm.secciones.push(seccion);
    });
    this.$store.commit("saveSecciones", [].concat(vm.secciones));
    let idioma = await Servicios.ObtenerCulture();
    console.log("ObtenerCulture", idioma.data.d);
    this.$i18n.locale = idioma.data.d;

  },
  mounted() {
    this.$store.commit("loadFromLocalStorage");
    const c =  this.$cookies.get("Idioma");
    console.log("IDIOMA => ", c )
    if(c) {
      this.$i18n.locale = c;
    } 
  },
};
</script>
